import { takeLatest, call } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { setSctProcsOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getSctProcsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const sctProcsOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getSctProcsOptions])
    const { entity } = sctProcsOptionsResponse
    yield put(setSctProcsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSctProcsOptions() error: ${e}`))
  }
}

export function* getSctProcsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSctProcsOptions)
}
